// extracted by mini-css-extract-plugin
export default {"buttonBox":"admin_buttonBox__ngs1s"};